import AddressApiClient from "@/api/addressApiClient";
import { AddressFieldValue } from "@ucl/library";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";

export const useAddressApiClient = () => {
  const addressApiClient = useAuthenticatedApiClient(AddressApiClient);

  return {
    getAddressesByQuery: (address: Partial<AddressFieldValue>) =>
      addressApiClient.getAddressesByQuery(address),
    getAddressByQuery: (address: AddressFieldValue) => addressApiClient.getAddressByQuery(address),
  };
};
